<template>
  <div class="container my-4">
    <router-link :to="{ name: 'DevicesView' }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />Geräte
    </router-link>
    <div class="d-flex align-items-center justify-content-between mt-3 mb-4 pb-4 border-bottom">
      <h4 class="mb-0">{{ deviceName }}</h4>
      <div>
        <b-dropdown right text="Funktionen" variant="outline-primary">
          <b-dropdown-item v-on:click="platzhalterSpeichern">
            <fa-icon :icon="['fas', 'plus']" fixed-width class="mr-2" />Platzhalter erstellen
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'CreateConfigurationView', query: { deviceName: encodeURI(deviceName) } }">
            <fa-icon :icon="['fas', 'plus']" fixed-width class="mr-2" />Konfiguration erstellen
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :to="{ name: 'ConfigurationFiltersView', query: { deviceName: encodeURI(deviceName) } }">
            <fa-icon :icon="['fas', 'filter']" fixed-width class="mr-2" />Filter bearbeiten
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'ChangeConfigurationOrderView', query: { deviceName: encodeURI(deviceName) } }">
            <fa-icon :icon="['fas', 'sort']" fixed-width class="mr-2" />Reihenfolge bearbeiten
          </b-dropdown-item>

          <!--Opens the configuration component: ComponentOverviewExport, allowing the user to select a specific
          configuration based on the selected device for download. -->
          <b-dropdown-item @click="$bvModal.show('exportConfigModal')">
            <fa-icon :icon="['fas', 'file-export']" fixed-width class="mr-2" />
            Komponentenübersichten
            exportieren
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row justify-content-start" v-if="isLoading === false">
      <ConfigurationCardComponent v-for="element in konfigurationen" :key="`konfiguration-${element.id}`"
        :configuration="element" v-on:showDownloadModal="showDownloadModal"
        v-on:dupliziereKonfiguration="dupliziereKonfiguration" v-on:loescheKonfiguration="loescheKonfiguration" />
    </div>
    <SpinnerComponent v-else />
    <b-modal id="download-modal" size="sm" hide-footer>
      <a :href="downloadURL" target="_blank" class="btn btn-outline-primary btn-block">Datei herunterladen</a>
    </b-modal>

    <b-modal ref="exportConfigModal" id="exportConfigModal" title="Konfiguration für das gewünschte Gerät auswählen"
      no-close-on-backdrop size="lg" scrollable>

      <template>
        <ComponentOverviewExport ref="componentOverviewExport" :deviceMainName="deviceName"
          :configurationsData="konfigurationen" @hideTheFirstModal="closeExportConfigModal" />
      </template>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <button class="btn btn-primary" @click="triggGenerateExclFile()">
          Auswahl
          herunterladen
          <fa-icon :icon="['fas', 'download']" fixed-width class="mr-2" />
        </button>
        <b-button class="btn" variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import ConfigurationCardComponent from '../components/ConfigurationCardComponent'
import SpinnerComponent from '../components/SpinnerComponent'
import ComponentOverviewExport from '../components/ComponentOverviewExport.vue'
import { firestore } from "../plugins/firebase"
import { addDoc, collection, query, getDocs, orderBy, doc, getDoc, deleteDoc } from "firebase/firestore"


export default {
  name: 'ConfigurationsView',
  components: {
    ConfigurationCardComponent,
    SpinnerComponent,
    ComponentOverviewExport
  },
  computed: {
    deviceName: function () {
      return decodeURI(this.$route.query.deviceName)
    },
    deviceId: function () {
      return decodeURI(this.$route.params.deviceId)
    }
  },
  data() {
    return {
      isLoading: true,
      konfigurationen: [],
      downloadURL: '',
      showConfigModal: false
    }
  },
  mounted() {
    this.ladeKonfigurationen()
  },
  methods: {
    closeExportConfigModal() {
      this.$refs.exportConfigModal.hide();
    },
    triggGenerateExclFile() {
      this.$refs.componentOverviewExport.generateExclFile();
    },

    platzhalterSpeichern() {

      addDoc(collection(firestore, 'konfigurationen'), {
        selectedStatus: 'platzhalter',
        orderIndex: 0,
        bild: '',
        name: 'Platzhalter',
        artikelnummerPraefix: '',
        code: '',
        dac: '',
        deviceId: this.deviceId,
        datenblatt: '',
        herstellernummer: '',
        skontoR1: '',
        uhg: '',
        uvpBrutto: '',
        warengruppe: '',
        deluxeBeschreibungstext: '',
        shopBeschreibungstext: '',
        gewaehlteKomponenten: []
      })
        .then(() => this.ladeKonfigurationen())
        .catch(error => console.error(error)) // eslint-disable-line no-console
    },
    hideModal: function (modal) {
      this.$bvModal.hide(modal)
    },
    showDownloadModal: function (downloadURL) {
      this.downloadURL = downloadURL
      this.$bvModal.show('download-modal')
    },
    ladeKonfigurationen: async function () {
      this.konfigurationen = []

      const q = query(collection(firestore, 'konfigurationen'), orderBy('orderIndex', 'asc'))

      await getDocs(q)
        .then(docs => {
          this.isLoading = false
          docs.forEach(document => {
            if (document.data().deviceId === this.deviceId) {
              const element = {
                id: document.id,
                data: document.data()
              }
              this.konfigurationen.push(element)
            }
          })
        })
        .catch(err => { console.error(err) })
    },
    dupliziereKonfiguration: async function (data) {

      const docRef = doc(firestore, "konfigurationen", data.id);
      const docSnap = await getDoc(docRef);

      let configuration

      if (docSnap.exists) {
        configuration = docSnap.data()
      } else {
        this.$bvModal.msgBoxOk('Die Konfiguration konnte nicht duplizieret werden.', {
          title: '',
          okVariant: 'primary',
          okTitle: 'OK',
          hideHeaderClose: false,
          noCloseOnBackdrop: true
        })
          .catch(error => console.error(error)) // eslint-disable-line no-console
      }
      configuration.name += ' - Kopie'

      addDoc(collection(firestore, "konfigurationen"), configuration)
        .then(() => {
          this.konfigurationen = []
          this.ladeKonfigurationen()
        })
    },
    loescheKonfiguration: function (data) {
      this.$bvModal.msgBoxConfirm(`Soll die Konfiguration "${data.name}" wirklich gelöscht werden?`, {
        title: '',
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'Abbrechen',
        hideHeaderClose: false,
        noCloseOnBackdrop: true
      })
        .then(value => {
          if (value === true) {
            deleteDoc(doc(firestore, "konfigurationen", data.id))
              .then(() => {
                for (let i = 0; i < this.konfigurationen.length; i++) {
                  if (this.konfigurationen[i].id === data.id) {
                    this.konfigurationen.splice(i, 1)
                    i--
                  }
                }
              })
              .catch(error => console.error(error)) // eslint-disable-line no-console
          }
        })
        .catch(error => console.error(error)) // eslint-disable-line no-console
    }
  }
}
</script>

<style>
table tr td:hover {
  cursor: grab;
}

table tr.sortable-chosen td:hover {
  cursor: grabbing !important;
}

.close-export-config-modal {
  background-color: white !important;
  border: none;
  font-size: large;
  font-weight: 700;
}
</style>